import auth from '@/auth'
import monitor, { legacyRoleContext } from '@/lib/monitor'
import store from '@/store'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import adminRoutes from './admin/routes'
import orgRoutes from './organisation/routes'
import eventRoutes from './event/routes'
import userRoutes from './user/routes'
import localRoutes from './local/routes'

import judgeRoutes from '@/judge/routes'
import supervisorRoutes from '@/supervisor/routes'
import duelsRoutes from '@/duels/routes'
import cisRoutes from '@/cis/routes'

let routes = [
  {
    path: '/login',
    name: 'login',
    component: require('@/components/loginPage.vue').default,
    beforeEnter: function (to, from, next) {
      /*if (store.state.environment.local && ! store.state.environment.localUser) {
        console.log('no local user')
        return next({path: 'importer/login'})
      }*/

      if (to.query.userId && to.query.token) {
        const token = {
          id: to.query.token,
          userId: to.query.userId,
        }
        let dest = 'homepage'
        if (to.query.destination) {
          dest = to.query.destination
        }
        auth.setToken(token, dest).then(() => {
          next()
        }, err => { console.log(err) })
      } else {
        next()
      }
    }
  },
  {
    path: '/admin-login',
    name: 'admin-login',
    component: require('@/components/adminLoginPage.vue').default,
  },
  localRoutes,
  {
    path: '/logout',
    name: 'logout',
    component: require('@/components/wrapper.vue').default,
    beforeEnter: function (to, from, next) {
      auth.logout()
      let name = 'login'
      if (store.state.environment.local) {
        name = 'local.events'
      }

      next({ name })
    }
  },
  {
    path: '/',
    name: 'base',
    component: require('./appLayout.vue').default,
    beforeEnter: function (to, from, next) {
      console.log('entering base')
      auth.checkToken().then(() => {
        console.log('token valid')
        if (to.name === 'base') {
          console.log('redirecting to homepage')
          next(store.state.user.homepage)
        }
        next()
      }).catch(err => {
        console.log('no valid token', err)
        let name = 'login'
        if (store.state.environment.local) {
          name = 'local.events'
        }

        next({ name })
      })
    },
    children: [
      eventRoutes,
      orgRoutes,
      adminRoutes,
      userRoutes,
    ],
  },
  judgeRoutes,
  supervisorRoutes,
  duelsRoutes,
  cisRoutes,
]

// TODO: redefine redirection based on logged in user
routes = routes.concat([{path: '*', redirect: '/admin'}])

const router = new VueRouter({
  routes,
  linkActiveClass: 'is-active',
})

router.beforeEach(async (to, from, next) => {
  const context = legacyRoleContext(to)
  if (!context) {
    monitor.stop()
    return next()
  }
  monitor.stop()
  try {
    await auth.checkToken()
    await monitor.open(context)
    if (!store.state.events.countries.length) {
      const result = await Vue.http.get('/api/countries', { params: { filter: { order: 'name' } } })
      store.commit('events.setCountries', result.data)
    }
    next()
  } catch (error) {
    monitor.stop()
    next({ path: '/login' })
  }
})
router.afterEach(to => {
  if (legacyRoleContext(to)) monitor.start()
  else monitor.stop()
})


export default router
